import { Modal } from "react-bootstrap";
import { RoomsInfo } from "../../rooms-info";
import ImageGallery from "react-image-gallery";

export function ViewGallery({show, imagesList, handleClose}){
    const state = {
        showThumbnails : false,
        showBullets: true,
        showFullscreenButton: false, 
        showPlayButton: false
    };

    return (
        <Modal show={show} onHide={() => handleClose()}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <ImageGallery items={imagesList} showThumbnails={state.showThumbnails}
                    showBullets = {state.showBullets} showPlayButton={state.showPlayButton} showFullscreenButton={state.showFullscreenButton}/>
            </Modal.Body>
        </Modal>
    )
}